export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    role: '资深读者 · 阅读超200部',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20young%20male%20reader%2C%20simple%20circle%20avatar%2C%20warm%20friendly%20expression%2C%20clean%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    title: '找了好久终于找到了！',
    content: '之前在其他平台看韩漫总是各种删减和广告，体验太差了。韩漫大全真的很棒，完整无删减，而且还能下拉式阅读，简直不要太舒服！',
    rating: 5,
  },
  {
    id: 2,
    name: '夜猫子读者',
    role: '忠实用户 · 使用6个月',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20young%20female%20reader%2C%20simple%20circle%20avatar%2C%20warm%20gentle%20expression%2C%20clean%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    title: '资源丰富，更新超快！',
    content: '每天晚上刷韩漫大全已经成为我的习惯了，更新速度快，种类丰富。漫画无删减看得非常过瘾，强烈推荐给所有韩漫爱好者！',
    rating: 5,
  },
  {
    id: 3,
    name: '追漫达人阿琳',
    role: '韩漫收藏家 · 收藏超500部',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20dedicated%20female%20reader%2C%20simple%20circle%20avatar%2C%20enthusiastic%20expression%2C%20clean%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    title: '下拉式阅读体验满分',
    content: '下拉式阅读的设计太贴心了，一口气看完一章根本停不下来。界面干净没有广告，版面和字体大小都很舒适，是我用过最好的韩漫平台。',
    rating: 5,
  },
  {
    id: 4,
    name: '资深漫评人',
    role: '动漫博主 · 10年漫龄',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20professional%20male%20critic%2C%20simple%20circle%20avatar%2C%20thoughtful%20expression%2C%20clean%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-user-04&orientation=squarish',
    title: '高质量的无删减内容',
    content: '作为漫评人，我看过很多平台。韩漫大全在内容质量上确实做得很用心，无删减、画质清晰，对于想要完整体验韩漫魅力的读者来说是最佳选择。',
    rating: 5,
  },
  {
    id: 5,
    name: '上班族小陈',
    role: '休闲读者 · 每日必追',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20office%20worker%20male%2C%20simple%20circle%20avatar%2C%20relaxed%20expression%2C%20clean%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-user-05&orientation=squarish',
    title: '通勤路上必备神器',
    content: '每天上下班路上打开韩漫大全看看最新更新，下拉式阅读单手就能操作，非常方便。无广告、免费阅读，性价比简直无敌。',
    rating: 4,
  },
  {
    id: 6,
    name: '学生党阿杰',
    role: '新用户 · 使用1个月',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20young%20student%20male%2C%20simple%20circle%20avatar%2C%20happy%20expression%2C%20clean%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-user-06&orientation=squarish',
    title: '免费又好用，良心平台！',
    content: '学生党预算有限，韩漫大全完全免费真的很良心。漫画种类多、更新快，还能无删减阅读，身边同学都被我安利过来了。',
    rating: 5,
  },
];

export const faqItems = [
  {
    question: '韩漫大全是什么平台？',
    answer: '韩漫大全是一个专注于提供韩国漫画无删减内容的免费在线阅读平台。我们收录了海量优质韩漫资源，支持下拉式阅读体验，无需翻页，流畅阅读，致力于为广大韩漫爱好者提供纯净、便捷的阅读服务。',
  },
  {
    question: '韩漫大全的漫画是否完全免费？',
    answer: '是的，韩漫大全上所有漫画内容目前均免费提供。我们坚持免费模式，让每一位韩漫爱好者都能无障碍地享受高质量的漫画阅读体验。未来如有任何调整，我们会提前公告通知。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是韩漫大全的特色功能之一。读者无需点击翻页按钮，只需向下滑动页面即可连续阅读下一章节内容，如同刷社交媒体一般流畅自然。在任意漫画详情页点击开始阅读，即可体验下拉式阅读的畅快感受。',
  },
  {
    question: '漫画是否有删减或打码？',
    answer: '韩漫大全承诺所有漫画内容均为原版无删减版本，保持韩国原版漫画的完整性。我们尊重创作者的劳动成果，致力于为读者呈现最真实、最完整的漫画作品。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页顶部的搜索栏输入漫画名称、作者或关键词进行搜索。同时，您也可以通过浏览不同分类页面，如奇幻冒险、恋爱都市、悬疑动作等分类，发现感兴趣的漫画作品。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '韩漫大全与创作者保持紧密合作，热门连载漫画通常保持每周1-3次更新。具体的更新频率因作品而异，您可以在漫画详情页查看最新的更新状态和章节信息。',
  },
];